import { gql } from "@apollo/client";

export const UPDATE_TOWER_MUTATION = gql`
  mutation UpdateTower($towerData: TowerInput!, $tower_id: Int!) {
    updateTower(towerData: $towerData, towerId: $tower_id) {
      tower {
        id
        w3w
        zonkeId
        vrmPortalId
        installDate
        numberChannels
        port
      }
    }
  }
`;
